import type { EventName } from "@lit/react";
import { Dialog as DialogElement, type DialogEventMap as _DialogEventMap, } from "@vaadin/dialog/vaadin-dialog.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { DialogElement, };
export type DialogEventMap = Readonly<{
    onClosed: EventName<_DialogEventMap["closed"]>;
    onDragStart: EventName<_DialogEventMap["drag-start"]>;
    onDragged: EventName<_DialogEventMap["dragged"]>;
    onOpenedChanged: EventName<_DialogEventMap["opened-changed"]>;
    onResize: EventName<_DialogEventMap["resize"]>;
    onResizeStart: EventName<_DialogEventMap["resize-start"]>;
}>;
const events = { onClosed: "closed", onDragStart: "drag-start", onDragged: "dragged", onOpenedChanged: "opened-changed", onResize: "resize", onResizeStart: "resize-start" } as DialogEventMap;
export type DialogProps = WebComponentProps<DialogElement, DialogEventMap>;
export const Dialog = createComponent({
    elementClass: DialogElement, events, react: React, tagName: "vaadin-dialog"
});
